import React, { lazy, Suspense } from 'react';
import { THDPassBusEvents, } from '../../../models/common/payments';
import { triggerLifeCycleEventBus } from '../../../utils/general';
import { track } from '../../../utils/analytics';
import { TAlertStatus } from '../../../models/common/alert-messages';
import { HD_PASS_SUCCESS_AUTH_MSG } from '../../../constants/response-success-messages';
import { usePayments } from '../../../hooks/use-payments';
const AuthHdPassFormDynamicImport = lazy(() => import('./auth-hd-wallet-form'));
export const HDPassOrangePayContainer = ({ card, onCloseForm, onSuccess, onFailure }) => {
    const { setAlertMessage } = usePayments();
    const sendCancelMessage = () => {
        track('home-depot-wallet.actions.button-click', {
            actionType: 'cancel',
        });
        triggerLifeCycleEventBus('HD_WALLET.ACTION', THDPassBusEvents.CANCELLED);
        onCloseForm();
    };
    const onFailureWrapper = (data) => {
        track('home-depot-wallet.post-page-error', {
            displayType: 'inline',
            message: data.errorMessage,
            code: data.errorCode,
            type: 'error',
            pageSection: 'hd pass: authorize card',
        });
        if (onFailure) {
            onFailure();
        }
    };
    const onSuccessWrapper = () => {
        triggerLifeCycleEventBus('HD_WALLET.ACTION', THDPassBusEvents.ENROLLED, {
            paymentId: card === null || card === void 0 ? void 0 : card.paymentId,
        });
        if (card === null || card === void 0 ? void 0 : card.paymentId) {
            setAlertMessage({
                paymentId: card === null || card === void 0 ? void 0 : card.paymentId,
                alertStatus: TAlertStatus.SUCCESS,
                text: HD_PASS_SUCCESS_AUTH_MSG.message,
            });
        }
        onSuccess();
    };
    return typeof window !== 'undefined' ? (React.createElement(Suspense, { fallback: React.createElement("div", null) },
        React.createElement(AuthHdPassFormDynamicImport, { card: card, onCancel: sendCancelMessage, onSuccess: onSuccessWrapper, onFailure: onFailureWrapper }))) : (React.createElement("div", null));
};
